/*jslint browser: true*/ /*global jQuery,$*/

(function ($) {
    Inputmask.extendAliases({
        sonnysIp: {
            alias: 'ip',
            placeholder: "\u2000"
        },
        sonnysMac: {
            alias: 'mac',
            placeholder: "\u2000"
        },
        sonnysPhone: {
            alias: 'phone',
            placeholder: "\u2000"
        }
    });
    $('input.mask-ipv4').inputmask('sonnysIp');
    $('input.mask-mac').inputmask('sonnysMac');
    $('input.mask-phone').inputmask('sonnysPhone');
})(jQuery);
